const COOKIE_CONSENT_KEY = 'cookie_consent_choice';
const COOKIE_CONSENT_VERSION = '1';

const banner = document.getElementById('CookieConsent');
if (banner) {
  const stored = localStorage.getItem(COOKIE_CONSENT_KEY);

  if (!stored) {
    setTimeout(() => banner.classList.add('is-visible'), 800);
  }

  banner.querySelector('[data-cookie-accept]')?.addEventListener('click', () => {
    localStorage.setItem(COOKIE_CONSENT_KEY, JSON.stringify({ choice: 'accepted', version: COOKIE_CONSENT_VERSION }));
    hideBanner();
    window.dispatchEvent(new CustomEvent('cookie:accepted'));
  });

  banner.querySelector('[data-cookie-decline]')?.addEventListener('click', () => {
    localStorage.setItem(COOKIE_CONSENT_KEY, JSON.stringify({ choice: 'declined', version: COOKIE_CONSENT_VERSION }));
    hideBanner();
  });

  function hideBanner() {
    banner.classList.remove('is-visible');
    setTimeout(() => banner.remove(), 400);
  }
}

window.getCookieConsent = function () {
  const stored = localStorage.getItem(COOKIE_CONSENT_KEY);
  if (!stored) return null;
  try {
    return JSON.parse(stored);
  } catch {
    return null;
  }
};
